import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

import CheckboxInput, { CheckboxInputProps } from './CheckboxInput'
import { FormControl, FormHelperText } from '@mui/material'
import ErrorMessage from '@/components/formik/messages/ErrorMessage'

type CheckboxInputControllerProps<T extends FieldValues> = UseControllerProps<T> & Omit<CheckboxInputProps, 'onBlur' | 'onChange' | 'value'>

export default function CheckboxInputController<T extends FieldValues>(props: CheckboxInputControllerProps<T>) {
  const { control, name, ...rest } = props
  const {
    field: { ref, value, ...otherFields },
    fieldState: { error },
  } = useController({ name, control })

  return (
    <FormControl error={!!error}>
      <CheckboxInput {...rest} {...otherFields} checked={value} />
      {error?.message && (
        <FormHelperText sx={{ mt: 0 }}>
          <ErrorMessage error={error.message} />
        </FormHelperText>
      )}
    </FormControl>
  )
}
